import { MemberProps } from 'app/components/Core/convention'
import KUnit from 'app/components/Modules/DataDisplay/KUnit'
import { FC } from 'react'

const QuantityWithUnitCell: FC<MemberProps<ILineItem>> = ({ member }) => {
  const { validDisplayUnit, displayUnitWithQuantity, quantity, unit } = member

  if (validDisplayUnit) return displayUnitWithQuantity

  return <KUnit member={unit} props={{ count: quantity }} />
}

export default QuantityWithUnitCell
